
import { NAME_SPACE } from './constants'
import moment from 'moment'
import { 
    getOverviewDataApi,
    getHistoryDataApi,
    getHistoryDataDecomposeApi,
    getDataExportApi,
    getCanSelectApi,
    getTendencyApi
 } from './service'
const initState = () => ({
    loading: {
        getOverviewDataLoading: false,
        getHistoryDataLoading: false,
        getHistoryDataDecomposeLoading: false,
        getDataExportLoading: false,
        getTendencyLoading: false
    },
    changeTag: {
        historyChangeIndex: 0,
        overviewChangeIndex: 0,
        historyDataDecomposeChangeIndex: 0,
        dataExportIndex: 0,
        oldAndNewIndex: 0
    },
    historyData: null,
    overviewData: null,
    historyDataDecompose:null,
    dataExportData: null,
    echartsResize:[],
    teamList:[],
    tendencyList: []
})
// getHistoryDataApi
const model = {
    name: NAME_SPACE,
    namespaced: true,
    state: initState(),
    mutations: {
        setStateLevel0(state, params) {
            if (Object.prototype.toString.call(params) === '[object Object]') {
                const { key, value} = params
                state[key] = value
                return 
            }
            for (const item of params) {
                const { key, value} = item
                state[key] = value
            }
        },
        setLoading(state, { key, value }) {
            state.loading[key] = value
        },
        setChangeTag(state, { key }) {
            state.changeTag[key] = state.changeTag[key] + 1
        },
        detialEditDestryed(state) {
            state.tree = []
        },
        resizeCall(state, params) {
            if (params === 'all') {
                state.echartsResize.forEach(call => call());
            } else {
                state.echartsResize.forEach(call => {
                    if (params.includes(call)) {
                        call()
                    }
                });
            }

        },
        addEchartsResize(state, call) {
            if (Object.prototype.toString.apply(call) === '[object Array]') {
                call.forEach(item => {
                    state.echartsResize.push(item)  
                })
                return 
            }
            state.echartsResize.push(call)
        },
        initState(state) {
            const stateInit = initState()
            Object.keys(state).forEach(key => {
                state[key] = stateInit[key]
            })
        }
    },
    actions: {
        // 获取Overviews数据
        async getOverviewData({ commit }, params) {
            commit('setLoading', { key:'getOverviewDataLoading', value:true })
            const result = await getOverviewDataApi({params}, () => {
                commit('setLoading', { key:'getOverviewDataLoading', value:false })
            })
            commit('setStateLevel0', { key:'overviewData', value:result })
            commit('setChangeTag', { key:'overviewChangeIndex' })
        },
        // 获取历史数据数据
        async getHistoryData({ commit }, params) {
            commit('setLoading', { key:'getHistoryDataLoading', value:true })
            const result = await getHistoryDataApi({ params }, () => {
                commit('setLoading', { key:'getHistoryDataLoading', value:false })
            })
            commit('setStateLevel0', { key:'historyData', value:result })
            commit('setChangeTag', { key:'historyChangeIndex' })
        },
        // 获取历史分解数据
        // getHistoryDataDecomposeApi
        async getHistoryDataDecompose({ commit }, params) {
            commit('setLoading', { key:'getHistoryDataDecomposeLoading', value:true })
            const result = await getHistoryDataDecomposeApi({ params:{...params, month:moment(params.month).format('YYYY-MM')} }, () => {
                commit('setLoading', { key:'getHistoryDataDecomposeLoading', value:false })
            })
            commit('setStateLevel0', { key:'historyDataDecompose', value:result })
            commit('setChangeTag', { key:'historyDataDecomposeChangeIndex' })
        },
        async getDataExport({ commit }, params) {
            // getDataExportApi
            commit('setLoading', { key:'getDataExportLoading', value:true })
            const result = await getDataExportApi({ params }, () => {
                commit('setLoading', { key:'getDataExportLoading', value:false })
            })
            commit('setStateLevel0', { key:'dataExportData', value:result })
            commit('setChangeTag', { key:'dataExportIndex' })
        },
        async getCanSelect({ commit }) {
            const result = await getCanSelectApi()
            commit('setStateLevel0', { key:'teamList', value:result.teams || [] })
        },
        async getTendency({commit}, params) {
            commit('setLoading', { key:'getTendencyLoading', value:true })
            const result = await getTendencyApi({ params }, () => {
                commit('setLoading', { key:'getTendencyLoading', value:false })
            })
            commit('setChangeTag', { key:'oldAndNewIndex' })
            commit('setStateLevel0', { key:'tendencyList', value:result || {} })
        }
    }
  };
  
  export default model;
  